<template>
  <img
    :src="logoSrc"
    :alt="alt"
    v-bind="$attrs"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import { BRAND } from '@/config/branding';

export default {
  name: 'AppLogo',
  props: {
    alt: {
      type: String,
      default: 'Logo'
    }
  },
  computed: {
    ...mapGetters(['isDarkMode']),
    logoSrc() {
      // Carpeta seleccionada por VUE_APP_BRAND_LOGO_DIR (ver branding.js).
      // webpack genera un context con todas las carpetas de imagenes/<hotel>/.
      const variante = this.isDarkMode ? 'dark' : 'light';
      return require(`@/assets/imagenes/${BRAND.logoDir}/${variante}-logo.webp`);
    }
  }
};
</script>
